import styled from 'styled-components';

export const CoursesList = styled.div`
  display: inline-flex;
  gap: 2rem;
  flex-wrap: wrap;
  padding: 1rem;
  width: 100%;
  height: 100%;
  overflow: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const ContainerTable = styled.div`
  margin: auto;
  width: 98%;
`;

export const togleStyle = { display: 'flex', justifyContent: 'flex-end' };
export const dropdownStyle = { display: 'flex', justifyContent: 'flex-end' };

export default {
  CoursesList,
  togleStyle,
  dropdownStyle,
  ContainerTable,
};
